import React, { useEffect, useRef, useState } from "react";
import { useFormik } from "formik";
import Button from "react-bootstrap/Button";
import PhoneInput from "react-phone-input-2";
import { useDispatch, useSelector } from "react-redux";
import { Card, Col, Form, Row, Stack } from "react-bootstrap";
import { Link } from "react-router-dom";
import Create from "../../../Assets/icons/create.png";
import noimage from "../../../Assets/no-img/no-image-icon.png";
import { fetchBusinessProfileData } from "../../../redux/slice/BusinessProfileSlice";
import {
  fetchUserProfileData,
  UpdateBusinessProfile,
} from "../../../redux/slice/UserProfileSlice";
import Loader from "../../../components/Common/Loader/PrimaryLoader";
import { fetchsuperadminapproverdata } from "../../../redux/slice/CreateLocationSlice";
import ValidationSchema from "../../../components/Common/ValidationSchema";
import { StatusCode } from "../../../services/helper";
import ButtonLoader from "../../../components/Common/ButtonLoader";
import LocationPopup from "../../BusinessProfile/LocationPopup/LocationPopup";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { toast } from "react-toastify";
import { authUser } from "../../../redux/slice/AuthSlice";

const DistributorBusinessProfile = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedLocation, setSelectedLocation] = useState({});
  const [companyLogoPreview, setCompanyLogoPreview] = useState(null);
  const [whiteCompanyLogoPreview, setWhiteCompanyLogoPreview] = useState(null);

  //redux state
  const { status, BusinessProfileData } = useSelector(
    (state) => state.BUSINESSPROFILE
  );
  const { BusinessprofileForm, formloadstatus } = useSelector(
    (state) => state.BUSINESSPROFILEFORM
  );

  //redux functions
  const dispatch = useDispatch();

  //ref
  const whiteLogoRef = useRef();
  const secWhiteLogoRef = useRef();

  const userData = BusinessProfileData?.locations || [];
  const company = BusinessProfileData?.company || [];
  const companyEmail = company.distributor_email || "";
  const compNumber = company.distributor_email || "";

  //formik initial state
  const initialValues = {
    company_name: "",
    company_logo: null,
    country_code: "",
    contact_number: "",
    business_email: "",
    assigned_role: "",
    number: "",
    businessEmail: "",
    approver: "approver",
    latitude: "",
    longitude: "",
  };

  //formik functions
  const {
    values,
    errors,
    handleBlur,
    handleChange,
    touched,
    setValues,
    handleSubmit,
  } = useFormik({
    initialValues: initialValues,
    validationSchema: ValidationSchema.updateBusinessProfileUser,
    onSubmit: async (values) => {
      const payload = {
        company_name: values.company_name,
        country_code: values.country_code,
        contact_number: values.contact_number,
        // business_email: values.email,
        // assigned_role: values.assigned_role,
        company_logo: values.company_logo,
        company_white_logo: values.company_white_logo,
      };
      const res = await dispatch(UpdateBusinessProfile(payload));
      if (res?.payload?.status === 200) {
        dispatch(fetchUserProfileData());
        dispatch(authUser());
      }
    },
  });

  //lifycycle hooks
  useEffect(() => {
    setValues({
      ...values,
      company_name: BusinessprofileForm?.business_profile?.company_name || "",
      company_logo: BusinessprofileForm?.business_profile?.company_logo || "",
      company_white_logo:
        BusinessprofileForm?.business_profile?.company_white_logo || "",
      country_code: BusinessprofileForm?.business_profile?.country_code || "",
      contact_number:
        BusinessprofileForm?.business_profile?.contact_number || "",
      email: BusinessprofileForm?.business_profile?.email || "",
      assigned_role: BusinessprofileForm?.business_profile?.assigned_role || "",
    });
  }, [BusinessprofileForm]);

  const handleLogoChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      if (file.type.startsWith("image/")) {
        if (e.target.name === "company_logo") {
          setCompanyLogoPreview(URL.createObjectURL(file));
          setValues({ ...values, company_logo: file });
        } else {
          setWhiteCompanyLogoPreview(URL.createObjectURL(file));
          setValues({ ...values, company_white_logo: file });
        }
      } else {
        toast.error("Please select a valid image file");
      }
    }
  };

  useEffect(() => {
    dispatch(fetchBusinessProfileData());
    dispatch(fetchUserProfileData());
    dispatch(fetchsuperadminapproverdata());
  }, [dispatch]);

  //methods

  if (status === "loading" && !isModalOpen) {
    return (
      <div>
        <Loader />
      </div>
    );
  }

  const handleCardClick = (locationData) => {
    setSelectedLocation({
      ...locationData,
      country_code: locationData?.telephone.split(" ")[0],
      telephone: locationData?.telephone.split(" ")[1],
    }); // Set selected location data
    setIsModalOpen(true);
  };

  const handleCloseLocationPopup = () => {
    setIsModalOpen(false);
    setSelectedLocation({});
  };

  return (
    <Stack>
      <Row className="h-100 row-gap-3">
        {isModalOpen && (
          <LocationPopup
            isOpen={isModalOpen}
            onClose={handleCloseLocationPopup}
            selectedLocation={selectedLocation}
          />
        )}
        <Col xs={12} md={6} className="h-100">
          <Form
            onSubmit={handleSubmit}
            className="bg-white h-100 d-flex flex-column popup-layout"
            style={{ borderRadius: "16px" }}
          >
            <Stack className="h-100">
              <div
                className="position-sticky bg-white header-section"
                style={{ zIndex: 1 }}
              >
                <h4 className="text-center fw-bold m-0">Business Profile</h4>
                <hr />
              </div>
              <div className="pb-3">
                <div className="row g-0 row-gap-3 gx-xl-3">
                  <div className="col-12 col-xl-6">
                    <div className="companylogo text-center">
                      <Form.Group controlId="formBasiccompany_logo">
                        <Form.Control
                          ref={whiteLogoRef}
                          type="file"
                          accept="image/*"
                          name="company_logo"
                          className="d-none"
                          onChange={handleLogoChange}
                          onBlur={handleBlur}
                        />
                      </Form.Group>
                      <div className="p-2 w-100" style={{ height: "200px" }}>
                        <img
                          src={
                            values.company_logo === ""
                              ? noimage
                              : companyLogoPreview
                              ? companyLogoPreview
                              : values.company_logo
                          }
                          alt={
                            values.company_logo === ""
                              ? "noimage"
                              : "company logo"
                          }
                          className="w-100 h-100 object-fit-contain"
                        />
                      </div>
                    </div>
                    <div className="text-center pt-2">
                      <button
                        className="border-0 background-transparent"
                        type="button"
                        onClick={() => whiteLogoRef.current.click()}
                        style={{ fontSize: "14px" }}
                      >
                        Edit
                      </button>
                    </div>
                  </div>

                  <div className="col-12 col-xl-6">
                    <div className="companylogo text-center">
                      <Form.Group controlId="formBasiccompany_logo">
                        <Form.Control
                          ref={secWhiteLogoRef}
                          type="file"
                          accept="image/*"
                          name="company_white_logo"
                          className="d-none"
                          onChange={handleLogoChange}
                          onBlur={handleBlur}
                        />
                      </Form.Group>
                      <div className="p-2 w-100" style={{ height: "200px" }}>
                        <img
                          src={
                            values.company_white_logo === ""
                              ? noimage
                              : whiteCompanyLogoPreview
                              ? whiteCompanyLogoPreview
                              : values.company_white_logo
                          }
                          alt={
                            values.company_white_logo === ""
                              ? "noimage"
                              : "company logo"
                          }
                          className="w-100 h-100 object-fit-contain"
                        />
                      </div>
                    </div>
                    <div className="text-center pt-2">
                      <button
                        className="border-0 background-transparent"
                        type="button"
                        onClick={() => secWhiteLogoRef.current.click()}
                        style={{ fontSize: "14px" }}
                      >
                        Edit White Logo
                      </button>
                    </div>
                  </div>
                </div>
                <hr />
                <div className="row row-gap-3 g-0">
                  <Form.Group
                    className="col-12"
                    controlId="formBasicBusinessName"
                  >
                    <Form.Control
                      type="text"
                      name="company_name"
                      value={values.company_name}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      placeholder="Business Name"
                    />
                    {errors.company_name && touched.company_name && (
                      <p className="text-danger mt-1 mb-0">
                        {errors.company_name}
                      </p>
                    )}
                  </Form.Group>
                  <Form.Group
                    className="col-12"
                    controlId="formBasicBusinessName"
                  >
                    <div className="phn_input">
                      <div className="phone-input">
                        <PhoneInput
                          name="country_code"
                          country={""}
                          disableTyping={true}
                          inputProps={{
                            readOnly: true,
                          }}
                          value={values.country_code}
                          onChange={(value) =>
                            handleChange({
                              target: {
                                name: "country_code",
                                value: `+${value}`,
                              },
                            })
                          }
                        />
                      </div>
                      <Form.Control
                        onKeyPress={(e) => {
                          if (
                            e.key === "e" ||
                            e.key === "E" ||
                            isNaN(Number(e.key))
                          ) {
                            e.preventDefault();
                          }
                        }}
                        onKeyDown={(e) => {
                          if (e.key === " ") {
                            e.preventDefault();
                          }
                        }}
                        name="contact_number"
                        type="text"
                        pattern="[0-9]*"
                        value={values.contact_number}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        placeholder="Number"
                      />
                    </div>
                    <Stack direction="horizontal" gap={2}>
                      {errors.country_code && touched.country_code && (
                        <p className="text-danger mt-1 mb-0">
                          {errors.country_code}
                        </p>
                      )}
                      {errors.contact_number && touched.contact_number && (
                        <p className="text-danger mt-1 mb-0">
                          {errors.contact_number}
                        </p>
                      )}
                    </Stack>
                  </Form.Group>
                  <Form.Group
                    className="col-12"
                    controlId="formBasicBusinessEmail"
                  >
                    <Form.Control
                      type="email"
                      name="email"
                      value={values.email}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      placeholder="Business Email"
                      disabled
                    />
                    {errors.email && touched.email && (
                      <p className="text-danger mt-1 mb-0">{errors.email}</p>
                    )}
                  </Form.Group>
                  <hr className="m-0" />
                  <Form.Group
                    className="col-12"
                    controlId="formBasicAsignedSuperAdmin"
                  >
                    <Form.Label className="fw-bold">
                      Assigned Super Admin
                    </Form.Label>
                    <Form.Control
                      type="text"
                      disabled
                      name="assigned_role"
                      value={values.assigned_role}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      placeholder="Super Admin"
                    />
                    {errors.assigned_role && touched.assigned_role && (
                      <p className="text-danger mt-1 mb-0">
                        {errors.assigned_role}
                      </p>
                    )}
                  </Form.Group>
                  {/* <hr className="m-0" />
                <Form.Group
                  className="col-12 mb-3"
                  controlId="formBasicAsignegApprover"
                >
                  <Form.Label className="fw-bold">Assigned Approver</Form.Label>
                  <Form.Control
                    type="text"
                    disabled
                    name="approver"
                    value={values.approver}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    placeholder="Approver"
                  />
                </Form.Group> */}
                </div>
              </div>
            </Stack>
            <div className="footer-section position-sticky bg-white">
              <hr className="mt-0" />
              <div className="d-flex justify-content-end align-items-center gap-3 flex-wrap flex-wrap-reverse">
                <Button variant="dark flex-grow-1 flex-xxl-grow-0">
                  Cancel
                </Button>
                <Button
                  variant="primary"
                  type="submit"
                  className="p-auto px-xxl-5 flex-grow-1 flex-xxl-grow-0"
                >
                  {formloadstatus === StatusCode.LOADING ? (
                    <ButtonLoader />
                  ) : (
                    "Save Changes"
                  )}
                </Button>
              </div>
            </div>
          </Form>
        </Col>
        <Col xs={12} md={6} className="h-100">
          <Stack className="h-100 row-gap-3">
            <div className="kits_row px-0">
              <div className="top-btns">
                <Card style={{ borderRadius: 16, border: "none" }}>
                  <Link
                    to="/distributor-create-location"
                    style={{ textDecoration: "none", color: "inherit" }}
                  >
                    <Button
                      variant="primary"
                      className="icon-button column-gap-2"
                    >
                      <img src={Create} alt="User Icon" />
                      <h3 className="button-text m-0">Create Location</h3>
                    </Button>
                  </Link>
                </Card>
              </div>
            </div>
            <Form
              onSubmit={handleSubmit}
              className="bg-white h-100 d-flex flex-column popup-layout"
              style={{ borderRadius: "16px" }}
            >
              <div
                className="position-sticky bg-white header-section"
                style={{ zIndex: 1 }}
              >
                <h4 className="fw-bold m-0">Company Locations</h4>
                <hr />
              </div>
              <div className="flex-grow-1 position-relative">
                <div className="position-absolute w-100 h-100">
                  <Stack className="overflow-y-auto h-100">
                    {userData.map((location, index) => (
                      <div key={index}>
                        <Stack
                          direction="horizontal"
                          key={index}
                          className="p-2 cursor justify-content-between gap-3 hover-primary"
                          onClick={() => handleCardClick(location)}
                        >
                          <p className="m-0">{location.location_name}</p>
                          <p className="m-0">{location.country}</p>
                        </Stack>
                        <hr className="my-2" />
                      </div>
                    ))}
                  </Stack>
                </div>
              </div>
            </Form>
          </Stack>
        </Col>
      </Row>
    </Stack>
  );
};

export default DistributorBusinessProfile;
